// extracted by mini-css-extract-plugin
module.exports = {"label":"PaymentOverview_label_2nHBc","isLarge":"PaymentOverview_isLarge_3VyEA","paymentInput":"PaymentOverview_paymentInput_3-vnq"};